import $ from 'jquery';
import Backbone from 'backbone';
import { T_ } from '@shared/translation';
import { isValidEmail } from '@shared/utility-functions';
import { tagsSessionId } from '@shared/threatmetrix';
import { getCSRFToken } from '@shared/cookie';

/*
 * Signup model
 */
export default Backbone.Model.extend({
  defaults: {
    email: '',
    username: '',
    password: '',
    confirmpwd: '',
    looking_for: 'Both',
    coupon: '',
    thm_session: '',
    signup_skip_captcha: '',
    proj_id: '', // Local Jobs
    project_collaboration_invitation_token: '',
  },

  isValidEmail() {
    if (!isValidEmail(this.get('email'))) {
      const msg = T_('Please enter a valid email address');
      this.trigger('email:invalid', msg);
      return false;
    }

    this.trigger('email:valid');
    return true;
  },

  isValidUsername() {
      // Test length
    const length = this.get('username').length;
    if (length < 3 || length > 16) {
      const msg = T_('Username must be 3-16 characters');
      this.trigger('username:invalid', msg);
      return false;
    }
      // Test format
    const re = /^[a-z][a-z0-9]{2,15}$/i;
    if (!re.test(this.get('username'))) {
      const msg1 = T_('Username must be alphanumeric starting with a letter');
      this.trigger('username:invalid', msg1);
      return false;
    }
    this.trigger('username:valid');
    return true;
  },

  isValidPassword() {
    const pwd = this.get('password');
    const username = this.get('username');
      // Test format
    const re = /^.{6,}$/i;
    if (!re.test(this.get('password'))) {
      const msg = T_('Password must be 6 characters minimum');
      this.trigger('password:invalid', msg);
      return false;
    }
      // Test strength
    let strength = 0;
    strength += pwd.match(/\d/g) ? 2 : 0;
    strength += pwd.match(/[A-Z]/g) ? 4 : 0;
    strength += pwd.match(/[a-z]/g) ? 4 : 0;
    if (strength <= 4) {
      const msg2 = T_('Please provide a stronger password');
      this.trigger('password:invalid', msg2);
      return false;
    }
    if (pwd == username) {
      const msg3 = T_('Password must be different to username');
      this.trigger('password:invalid', msg3);
      return false;
    }
    this.trigger('password:valid');
    return true;
  },

  isValidConfirmpwd() {
    if (this.get('password') != this.get('confirmpwd')) {
      const msg4 = T_('Passwords do not match!');
      this.trigger('confirmpwd:invalid', msg4);
      return false;
    }
    this.trigger('confirmpwd:valid');
    return true;
  },

  isValidLookingFor() {
    if (!this.get('looking_for')) {
      const msg5 = T_('Please select a role');
      this.trigger('looking_for:invalid', msg5);
      return false;
    }
    this.trigger('looking_for:valid');
    return true;
  },

  isEmployer() {
    return this.get('looking_for') == 'Employer';
  },

  validate(attrs) {
    let isValid = true;
      // Email
    if (!attrs.email) {
      const msg6 = T_('Please enter an email address');
      this.trigger('email:invalid', msg6);
      isValid = false;
    } else {
      isValid &= this.isValidEmail();
    }
      // Username
    if (!attrs.username) {
      const msg7 = T_('Please enter a username');
      this.trigger('username:invalid', msg7);
      isValid = false;
    } else {
      isValid &= this.isValidUsername();
    }
      // Password
    if (!attrs.password) {
      const msg8 = T_('Please enter a password');
      this.trigger('password:invalid', msg8);
      isValid = false;
    } else {
      isValid &= this.isValidPassword();
    }
      // Confirmpwd
    if (!attrs.confirmpwd) {
      const msg9 = T_('Please re-enter your password');
      this.trigger('confirmpwd:invalid', msg9);
      isValid = false;
    } else {
      isValid &= this.isValidConfirmpwd();
    }
    if (!attrs.looking_for) {
      const msg10 = T_('Please select a role');
      this.trigger('looking_for:invalid', msg10);
      isValid = false;
    } else {
      isValid &= this.isValidLookingFor();
    }
    return isValid;
  },

  isAvailableUsername() {
    $.ajax({
      url: '/ajax/check-username-exist.php',
      context: this,
      type: 'GET',
      cache: false,
      data: {
        username: this.get('username'),
        json: true,
        validator: true,
      },
      dataType: 'JSON',
      success(resp) {
        if (resp) {
          this.trigger('username:available');
          return true;
        }

        const msg11 = T_('This username already exists, ' +
            'please choose another');
        this.trigger('username:invalid', msg11);
        return false;
      },
      error() {
          // Can't connect to server
        this.trigger('username:available');
        return true;
      },
    });
  },

  isAvailableEmail() {
    $.ajax({
      url: '/ajax/check-email-exist.php',
      context: this,
      type: 'GET',
      cache: false,
      data: {
        email: this.get('email'),
        json: true,
        validator: true,
      },
      dataType: 'JSON',
      success(resp) {
        if (resp) {
          this.trigger('email:available');
          return true;
        }

        const msg12 = T_('This email address is already in use');
        this.trigger('email:invalid', msg12);
        return false;
      },
      error() {
          // Can't connect to server
        this.trigger('email:available');
        return true;
      },
    });
  },

  signup() {
      // Validate the model first
    if (!this.validate({
      email: this.get('email'),
      username: this.get('username'),
      password: this.get('password'),
      confirmpwd: this.get('confirmpwd'),
      looking_for: this.get('looking_for'),
    })) {
      return false;
    }
      // Send POST request
    $.ajax({
      url: '/users/onsignup.php',
      context: this,
      type: 'POST',
      cache: false,
      data: {
        email: this.get('email'),
        newusername: this.get('username'),
        newuserpasswd: this.get('password'),
        newuserpasswd1: this.get('confirmpwd'),
        looking_for: this.get('looking_for'),
        coupon: this.get('coupon'),
        newsignup: true,
        ajax: true,
        inline_signup: true,
        captcha_breakpoint_id: this.get('captcha_breakpoint_id'),
        captcha_breakpoint_token: this.get('captcha_breakpoint_token'),
        page: window.location.pathname,
        thm_session: tagsSessionId,
        signup_skip_captcha: this.get('signup_skip_captcha'),
        proj_id: this.get('proj_id'), // Local Jobs: Add project id
        project_collaboration_invitation_token: this
          .get('project_collaboration_invitation_token'),
        csrf_token: getCSRFToken(),
      },
      dataType: 'JSON',
      success(resp) {
        if (resp.status == 'success') {
          this.trigger('success', { redirectUrl: resp.goto_url });
        } else if (resp.captcha_breakpoint_id &&
              resp.captcha_breakpoint_token && resp.public_key) {
          this.trigger('captcha', {
            signupModel: this,
            captcha_breakpoint_id: resp.captcha_breakpoint_id,
            captcha_breakpoint_token: resp.captcha_breakpoint_token,
            public_key: resp.public_key,
          });
        } else if (resp.reason) {
          this.trigger('error', resp.reason);
        } else {
          this.trigger('error', T_('Internal error'));
        }
      },
      error() {
        this.trigger('error', T_('Error: can\'t connect to server'));
      },
    });
  },
});
